import { render, staticRenderFns } from "./LinkOrDiv.vue?vue&type=template&id=45ecd3e2&functional=true&"
import script from "./LinkOrDiv.vue?vue&type=script&lang=js&"
export * from "./LinkOrDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports